// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__367BW","process_cell":"List_process_cell__1gu4c"};